import {Validators} from '@angular/forms';

export class SingleSplitLoanAmountModel {
  purchaseRefinanceAmount = {
    value: 0.00,
    validation: Validators.compose([
      Validators.required,
      Validators.pattern('[0-9.]*')
    ])
  };
  // insurance = {
  //     value: null,
  //     validation: Validators.compose([])
  // };
  // insuranceWarrantyAmount = {
  //     value: 0.00,
  //     validation: Validators.compose([
  //         Validators.required
  //     ])
  // };
  depositTradeAmount = {
    value: 0.00,
    validation: Validators.compose([
      Validators.required,
      Validators.pattern('[0-9.]*')
    ])
  };
  amountPaid = {
    value: 0.00,
    validation: Validators.compose([
      Validators.required,
      Validators.pattern('[0-9.]*')
    ])
  };
  subTotal = {
    value: 0.00,
    validation: Validators.compose([
      Validators.required,
      Validators.pattern('[0-9.]*')
    ])
  };
  originationFeeCheck = {
    value: false,
    validation: Validators.compose([])
  };
  originationFee = {
    value: 0.00,
    validation: Validators.compose([
      Validators.pattern('[0-9.]*'),
      Validators.min(1),
      Validators.required
    ])
  };
  applicationFee = {
    value: 400.00,
    validation: Validators.compose([
      Validators.pattern('[0-9.]*')
    ])
  };
  subtotalWithFees = {
    value: 0.00,
    validation: Validators.compose([])
  };
  brokerageFeeCheck = {
    value: false,
    validation: Validators.compose([])
  };
  brokerageFeeCapitalizedCheck = {
    value: null,
    validation: Validators.compose([])
  };
  brokerageFeePercentage = {
    value: 0.00,
    validation: Validators.compose([])
  };
  brokerageFee = {
    value: 0.00,
    validation: Validators.compose([
      Validators.min(1),
      Validators.pattern('[0-9.]*')
    ])
  };
  totalLoanAmount = {
    value: 0.00,
    validation: Validators.compose([
      Validators.required,
      Validators.pattern('[0-9.]*')
    ])
  };

  // insurance array
  insurances = {
    value: [],
    validation: Validators.compose([])
  };
}

export class InvidualInsuranceModel {
  insuranceId = {
    value: null,
    validation: Validators.compose([])
  };

  insuranceAmount = {
    value: 0.00,
    validation: Validators.compose([])
  };
}
